// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aerodrome-boundary-markers.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aerodrome-boundary-markers/aerodrome-boundary-markers.js';
import g1 from '../lessons/air-law/aerodrome-boundary-markers/air-taxiway-edge-markers.js';
import g2 from '../lessons/air-law/aerodrome-boundary-markers/arrester-cable-markings.js';
import g3 from '../lessons/air-law/aerodrome-boundary-markers/heliport-h-marking.js';
import g4 from '../lessons/air-law/aerodrome-boundary-markers/seaplane-dock-marking.js';

mount([g0, g1, g2, g3, g4]);
